import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { changeReportedBookingStatus, reportedBookingsListing, viewReportedBooking } from "../apis/apiHandler";

export const allReportedBookings = createAsyncThunk(
    'reported_booking/list',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await reportedBookingsListing(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const viewReportedBookingDetails = createAsyncThunk(
    'reported_booking/view',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await viewReportedBooking(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const changeReportedBookingsStatus = createAsyncThunk(
    'reported_booking/status',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await changeReportedBookingStatus(payload);
            if (response?.code === 200) {
                return response;
            }
            else {
                return rejectWithValue(response);
            }
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

const initialState = {
    loading: false,
    reportedBookingList: [],
    error: null,
    reportedBookingDetail: {},
    statusSuccess: false
};

const reportedBookingSlice = createSlice({
    name: 'reported_bookings',
    initialState,
    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(allReportedBookings.pending, (state) => {
                state.loading = true;
            })
            .addCase(allReportedBookings.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.reportedBookingList = payload?.data;
            })
            .addCase(allReportedBookings.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(viewReportedBookingDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(viewReportedBookingDetails.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.reportedBookingDetail = payload?.data;
            })
            .addCase(viewReportedBookingDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(changeReportedBookingsStatus.pending, (state) => {
                state.loading = true;
                state.statusSuccess = false;
                state.error = null;
            })
            .addCase(changeReportedBookingsStatus.fulfilled, (state) => {
                state.loading = false;
                state.statusSuccess = true;
            })
            .addCase(changeReportedBookingsStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.statusSuccess = false;
            })
    }
})

export default reportedBookingSlice.reducer;